export const visit = (vm, at) => {
at({ "en": { "multiAccountReferenceResolvers": { "duplicateLabelHandler": { "sharedAcross": "Shared across {{ accountNames }}", "alsoKnownAs": "Also known as: {{ aliases }}", "descriptionWithDetail": "{{ base }} \xB7 {{ detail }}" } } } });
};